import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { Subject } from '../../models/subjects/subject';
import { Response } from '@angular/http';
import { HttpClientService } from '../http-client/http-client.service';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
import { AddSubjectDto } from '../../models/subjects/dto/addSubjectDto';
import { SubjectSchedule } from '../../models/subjects/dto/SubjectSchedule';

@Injectable()
export class SubjectService {

    public subjects: Subject[];
    public subjectObject: any;

    constructor(
        private http: HttpClientService
    ) {
        this.subjects = [];
        this.subjectObject = {};
    }

    public getAll(): Observable<Subject[]> {
        if (!!this.subjects && this.subjects.length > 0) {
            return Observable.create((observer: Subscriber<Subject[]>) => {
                observer.next(this.subjects);
                observer.complete();
            });
        }
        const url = 'subjects/all';
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.subjects = r.Result;
                this.subjectObject = this.subjects.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('StudentService > getAll > response', r);
            }
            return this.subjects;
        }).catch(this.handleError);
    }

    public getAllByDivision(divisionId): Observable<SubjectSchedule[]> {
        // if (!!this.subjects && this.subjects.length > 0) {
        //     return Observable.create((observer: Subscriber<Subject[]>) => {
        //         observer.next(this.subjects);
        //         observer.complete();
        //     });
        // }
        const url = 'subjects/allbydivision/' + divisionId;
        return this.http.get(url).map(response => {
            let r = response.json();
            let subjects = [];
            if (r.ResultCode === 1) {
                // this.subjects = r.Result;
                subjects = r.Result;
                // this.subjectObject = this.subjects.reduce((result, s) => {
                //     result[String(s.Id)] = result[String(s.Id)] || {};
                //     result[String(s.Id)] = s;
                //     return result;
                // }, {});
            } else {
                console.error('StudentService > getAll > response', r);
            }
            return subjects;
        }).catch(this.handleError);
    }

    public getAllByDivisionLite(divisionId): Observable<SubjectSchedule[]> {
        const url = 'subjects/allbydivisionlite/' + divisionId;
        return this.http.get(url).map(response => {
            let r = response.json();
            let subjects = [];
            if (r.ResultCode === 1) {
                subjects = r.Result;
            } else {
                console.error('SubjectService > getAllByDivisionLite > response', r);
            }
            return subjects;
        }).catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public add(addSubjectDto: AddSubjectDto) {
        const url = 'subjects/add';
        return this.http.post(url, addSubjectDto).map(response => response.json())
            .catch(this.handleError);
    }

    public edit(addSubjectDto: AddSubjectDto) {
        const url = 'subjects/add';
        return this.http.post(url, addSubjectDto).map(response => response.json())
            .catch(this.handleError);
    }

    public getBySchoolYearAndShift(schoolYearId: number, shiftId: number): Observable<any[]> {
        const url = 'subjects/GetBySchoolYearAndShift/' + schoolYearId + '/' + shiftId;
        return this.http.get(url).map(response => {
            const r = response.json();
            return r.Result;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/subject/subject.service.ts